<div class="blogs header_top mt-4">
  <div class="container">
    <div class="header">
      <h4>Blogs</h4>
    </div>
    <div class="row">
      <!-- Main blog -->
      <div class="col-lg-8 col-md-8 col-sm-12 blog_detail_content">
        <img *ngIf="pageImage" [src]="pageImage" alt="Blog Image" class="img-fluid mb-3">
        <!-- <div [innerHTML]="trimDescriptionKeepImage(pageDescription, 150, true)"></div> -->
        <div [innerHTML]="safePageDescription"></div>
      </div>

      <!-- Recent blogs -->
      <div class="col-lg-4 col-md-4 col-sm-12 recent_blog">
        <h5><b>Recent Blogs</b></h5>
        <div *ngFor="let blog of recentBlogs" class="features_blog" [routerLink]="['/blog-detail', blog.slug]"
          style="cursor: pointer;">
          <!-- <h6>{{ blog.name }}</h6> -->
          <!-- <div [innerHTML]="trimDescriptionKeepImage(blog.content, 80, false)"></div> -->
           <img *ngIf="blog.image" [src]="apiUrl + '/' + blog.image" alt="Blog Image" class="img-fluid mb-2">
          <div [innerHTML]="extractFirstHeading(blog.description)"></div>
        </div>
      </div>
    </div>
  </div>
</div>